export default "__VITE_ASSET__BJ5n6Lu1__"